module.exports = __webpack_public_path__ + "img/huawei_t5_black.4ed2e1d8.png";